import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';


@Component({
    selector: 'app-managment-card',
    templateUrl: './managment-card.component.html',
    styleUrl: './managment-card.component.scss',
    imports: [CommonModule, RouterModule, MatIcon]
})
export class ManagmentCardComponent {
  @Input() title: string = '';
  @Input() icon: string = 'factory';
  @Input() bgColor: string = 'rougeNovo';
  @Input() textColor: string = '#9b9b9b';
  @Input() data: string = 'test data';
  @Input() routerLink: string = '';
  @Input() externalUrl: string = '';

  constructor(private router: Router) {}

  handleClick(): void {
    if (this.externalUrl) {
      window.open(this.externalUrl, '_blank', 'noopener,noreferrer');
    } else if (this.routerLink) {
      this.router.navigate([this.routerLink]);
    }
  }
}
